import API from './resources'

const actions = {
  async getUsers({ commit }, payload) {
  try {
    const response = await API.getUsers(payload);
    commit("SET_USERS", response.data);
    return response.data;
  } catch (error) {
    return error;
  }
},
async getUsersByEmail({ commit }, payload) {
  try {
    const response = await API.getUsersEmail(payload);
    commit("SET_USERS", response.data.content);
    commit("SET_TOTAL_PAGE", response.data);
    return response;
  } catch (error) {
    return error;
  }
},
async getUsersByName({ commit }, payload) {
  try {
    const response = await API.getUsersName(payload);
    commit("SET_USERS", response.data.content);
    commit("SET_TOTAL_PAGE", response.data);
    return response.data;
  } catch (error) {
    return error;
  }
},
async getUsersActaId({ commit }, payload) {
  try {
    const response = await API.getUsersActaId(payload);
    commit("SET_USERS_ACTA_ID", response.data);
    return response;
  } catch (error) {
    return error;
  }
},
 async getListFromUser({ commit }, payload) {
  try {
    const response = await API.getListFromUser(payload);
    commit("SET_USER_GROUPS", response.data);
    return response;
  } catch (error) {
    return error;
  }
},
async postListFromUser({commit}, payload) {
      try {
        const response = await API.postListFromUser(payload)
        commit("SET_USER_NEW_GROUPS");
        return response
      } catch (error) {
        return error
      }
    },
async deleteListFromUser(_, payload) {
      try {
        const response = await API.deleteListFromUser(payload)
        return response
      } catch (error) {
        return error
      }
    },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/user_management/actions.js